import React from 'react'
import { ContainerModal, ModalContent, CloseButton, ButtonAceptar, ButtonCancelar, ButtonGroup } from './modalStykes'

const Modal = ({
  isOpen,
  onClose,
  onConfirm,
  confirmText = "Aceptar",
  cancelText = "Cancelar",
  size,
  children,
}) => {
    if (!isOpen) return null;

    // Modo confirmación: solo si se pasa onConfirm. Sin él, el modal se
    // comporta como siempre (un único botón "Aceptar" que cierra).
    const isConfirm = typeof onConfirm === "function";

    const handleClose = () => {
      if (onClose) onClose();
    };

    const handleConfirm = () => {
      onConfirm();
    };

    return (
      <ContainerModal onClick={handleClose}>
        <ModalContent $size={size} onClick={(e) => e.stopPropagation()}>
          <CloseButton onClick={handleClose} aria-label="Cerrar">×</CloseButton>
          <div className="modal-body">{children}</div>
          {isConfirm ? (
            <ButtonGroup>
              <ButtonCancelar type="button" onClick={handleClose}>{cancelText}</ButtonCancelar>
              <ButtonAceptar type="button" onClick={handleConfirm}>{confirmText}</ButtonAceptar>
            </ButtonGroup>
          ) : (
            <ButtonAceptar type="button" onClick={handleClose}>Aceptar</ButtonAceptar>
          )}
        </ModalContent>
      </ContainerModal>
    );
};

export default Modal;
